module.exports = __webpack_public_path__ + "d26c15dd5edc3bfa100ecccc35e47c47.png";